import React from 'react'
import {Link, useNavigate, useLocation} from 'react-router-dom'
import { useState, useEffect, FormEvent  } from 'react';
import Loading from '../../COMPONENTS/Loading/Loading'
import Footer from '../../COMPONENTS/Footer/Footer';
import BackImage from './BackImage';
import { ToastContainer, toast } from "react-toastify"
import Loisirs from '../../../API/tourisme/loisir/index'
import Reservation from '../../../API/tourisme/reservation/index'
import { AnnoncesProps, CultureOptions, Currency} from "../../../props";

import axios from 'axios';

import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import { styled } from '@mui/material/styles';
import Typography from '@mui/material/Typography';
import { loadStripe } from '@stripe/stripe-js';
import { getPaymentStatus } from '../../../API/stripe/StripeTranction';
import { FedaCheckoutButton, FedaCheckoutContainer } from 'fedapay-reactjs';
import { Modal, Button } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import Create from '../../../Payment/Create';

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
    '& .MuiDialogContent-root': {
        padding: theme.spacing(2),
    },
    '& .MuiDialogActions-root': {
        padding: theme.spacing(1),
    },
}));

// Clé publique Stripe

const stripePromise = loadStripe(process.env.REACT_APP_STRIPE_PUBLIC_KEY as string);

function PaymentPopup({ open,dollarP, user_Id, montant, email, onSuccess, userPrenom,userNom, onClose } : {
    open :any, dollarP :any , user_Id:any, montant:any, email:any, onSuccess:any, userPrenom:any,userNom:any, onClose:any
}) {
    const [isDialogOpen, setIsDialogOpen] = useState(open);
    const {t} = useTranslation() as {t:(key:string)=>string}

    useEffect(() => {
        setIsDialogOpen(open);
    }, [open]);
    //console.log(email)
    const handleOpenAZ = () => {
    };


    const handleClose = () => {
        setIsDialogOpen(false);
        if (onClose) onClose();
    };


    const handlePayCancel = () => {
        //console.log('Paiement annulé');
        handleClose();
    };
    const PUBLIC_KEY = process.env.REACT_APP_PUBLIC_KEY;
    const checkoutButtonOptions = {
        public_key: PUBLIC_KEY,
        transaction: {
          amount: montant,
          description: 'Publicité sur Mon Bon Sejour',
          callback_url: '/Reservation_Loisirs',
          custom_metadata: {
                user_id: user_Id,
                //additional_info: 'Some additional info'
            }
        },
        currency: {
          iso: 'XOF'
        },
        customer: {
          lastname: userNom,
          firstname: userPrenom,
          email: email
        },
        button: {
          class: 'btn btn-primary',
          text: 'Payer ' + montant + ' FCFA'
        },
        onComplete(resp :any) {
            const FedaPay = (window as any)['FedaPay'];
          if (resp.reason === FedaPay.DIALOG_DISMISSED) {
            //window.location.reload();
            toast.success('Vous avez fermé la boite de dialogue');
          } else {
            setIsDialogOpen(false);
            onSuccess();


          }

          //console.log(resp.transaction);

        },
        onClose: handlePayCancel
      };

      // Lancer le paiement FedaPay
      const handlePayment = () => {
        const FedaPay = (window as any)['FedaPay'];
        FedaPay.init(checkoutButtonOptions).open();
      };

       //stripe
    const createPaymentSession = async () => {
        try {
            const successUrl = `${window.location.origin}/Reservation_Loisirs`;
            const response = await axios.post(`${process.env.REACT_APP_BASE_URL}/api/payment/stripe`, {
            provider: 'stripe',
            item_id: 'item_id',
            item_name: 'item',
            amount: Math.round((montant / dollarP) * 100),
            currency: 'USD',
            email: email,
            description: 'Réservation sur le site MonBonSejour',
            last_name: userNom,
            first_name: userPrenom,
            success_url: successUrl,
            customer_number:1,
          });

          if (response.data) {
            localStorage.setItem('sessionId', response.data.sessionId);
              return response.data.sessionId;

            } else {
                console.error("Erreur lors de la création de la session de paiement :", response.data);
            }
        } catch (error) {
            console.error("Erreur lors de la requête Card :", error);
        }
    };

    const handleStripePayment = async () => {
        const sessionId = await createPaymentSession();
        if (sessionId) {
            const stripe = await stripePromise;

            if (stripe) {
                const { error } = await stripe.redirectToCheckout({
                    sessionId: sessionId,
                });

                if (error) {
                    console.error("Erreur lors de la redirection vers Stripe :", error);
                } else {
                    // Paiement réussi, appel de la fonction onSuccess
                    // onSuccessStripe();
                }
            } else {
                console.error("Stripe n'a pas pu être initialisé.");
            }
        }
    };


    return (
        <BootstrapDialog 
                 onClose={handleClose} 
                 aria-labelledby="customized-dialog-title" 
                 open={isDialogOpen}
               >
               <DialogTitle 
                 sx={{ 
                   m: 0, 
                   p: 2, 
                   display: 'flex', 
                   alignItems: 'center', 
                   justifyContent: 'space-between' 
                 }} 
                 id="customized-dialog-title" 
                 className='text-[#FE7F2D]'
               >
                 <span className="flex items-center space-x-3">
                   <p>{t("Veuillez choisir le mode de paiement")}</p>
                 </span>
                 <IconButton 
                   aria-label="close" 
                   onClick={handleClose}
                   sx={{
                     color: (theme) => theme.palette.grey[500],
                   }}
                 >
                   <CloseIcon />
                 </IconButton>
               </DialogTitle>
           
               <DialogContent dividers>
                 <DialogActions
                   style={{
                     display: 'flex',
                     flexDirection: 'column',
                     width: '100%',
                     alignItems: 'center',
                     gap: '10px' // Remplace marginBottom pour un espacement plus uniforme
                   }}
                 >
                   {[
                     {
                       onClick: handleOpenAZ,
                       label: `AZ-PAY : ${montant} F CFA`
                     },
                     {
                       onClick: handleStripePayment,
                       label: `Carte bancaire : ${montant} F CFA`
                     },
                     {
                       onClick: handlePayment,
                       label: checkoutButtonOptions.button.text
                     }
                   ].map((buttonConfig, index) => (
                     <Button
                       key={index}
                       onClick={buttonConfig.onClick}
                       style={{
                         textTransform: 'none',
                         backgroundColor: '#233D4D',
                         color: 'white',
                         width: '100%',
                         display: 'flex',
                         justifyContent: 'center',
                         alignItems: 'center',
                         padding: '10px', // Ajout de padding pour une meilleure apparence
                         marginLeft: '10px', // Ajout de padding pour une meilleure apparence
                       }}
                     >
                       {buttonConfig.label}
                     </Button>
                   ))}
                 </DialogActions>
               </DialogContent>
            </BootstrapDialog>
    );
}

function ReservationTourisme() {

    type Errors = {
        [key:string]:string
    }
  const [loading, setLoading] = useState(true);

  localStorage.setItem('url', JSON.stringify('/Reservation_Loisirs'));
  localStorage.setItem("urlres",'/Dashboard/Publications/Loisirs_activites/Ajouter_les_activites')
    // États pour gérer le formulaire et le popup
    const [showPopup, setShowPopup] = useState(false);
    const [priceD, setPriceD] = useState(null);
    const [loisir, setLoisir] = useState<AnnoncesProps>();
    const [errors,setErrors] = useState<Errors>();
    const [open,setOpen] = useState(false);

    const location = useLocation();
    const id = location.state
    const [options, setOptions] = useState<CultureOptions>({
            id_currency: 1, 
            success_url:'' ,
            cancel_url:'',
            amount:0,
            customer: {
            id: 1,
            first_name: '',
            last_name: '',
            email: '',
            phone: '',
            code_country: ''
            },
            seller_number: 1
        });
    const [curr,setCurr] = useState<Currency>({
          id_currency: 1,
        });

    const navigate = useNavigate();

    const [data, setData] = useState(() => {
        // getting stored value
        const saved = localStorage.getItem("data");
        const initialValue = saved !== null ? JSON.parse(saved) : null;
        return initialValue;
    });

    const getLoisir = () => {
        Loisirs.getOne(id)
        .then((res:any) => {
            if (res.data.status === 201) {
                setLoisir(res.data.data)
                localStorage.setItem('identifiant_announce', res.data.data.id_announce);
               // console.log('Local Storage set:', localStorage.getItem('identifiant_announce'));

                localStorage.setItem('prix', res.data.data.price_announce);
                //console.log('Local Storage setprix:', localStorage.getItem('prix'));
            }
            //console.log(res);
        })
        .catch((err:any) => {
            console.log(err);
        })
        .finally(() => {
            setLoading(false);
        })

    }

    const getPriceDollar = async () => {
        try {
        const res = await axios.get(`${process.env.REACT_APP_BASE_URL}/api/prix/dollar`);
        //console.log(res.data.data.value_to_xof);
        setPriceD(res.data.data.value_to_xof);
        } catch (err) {
        console.log(err);
        }
    };


    let votrenom = null;

    if(data !== null && data.userLastname !== null && data.userName !== null )
    {
      votrenom = data.userLastname + ' ' + data.userName;
    }

    if(data !== null && data.userLastname !== null && data.userName === null)
    {
      votrenom = data.userLastname;
    }
    if(data !== null && data.userName !== null && data.userLastname === null)
    {
      votrenom = data.userName;
    }
    
    const [nom, setNom] = useState(votrenom || "")
    const [date, setDate] = useState("")
    const [heure, setHeure] = useState("")
    const [place, setPlace] = useState("")
    const [tel, setTel] = useState(data !== null ? data.userTel : "")
    const [usermail, setUserEmail] = useState(data !== null ? data.userMail : "")

    // Récupération des données du formulaire depuis le localStorage
    const savedFormData = localStorage.getItem('formData');
    const initialFormData = savedFormData ? JSON.parse(savedFormData) : {};


    const [formData, setFormData] = useState(initialFormData);

    const handleInputChange = (event: any) => {
    const { name, value } = event.target;
    setFormData((prevFormData: any) => {
        const newFormData = { ...prevFormData, [name]: value };
        localStorage.setItem('formData', JSON.stringify(newFormData));
        return newFormData;
    });
    };


    //console.log(formData)

    const id_announce = localStorage.getItem('identifiant_announce');
    const price = localStorage.getItem('prix');
    //const formData1 = localStorage.getItem('formData');
    const n = formData.nbre;
    const d = formData.date;
    const h = formData.time;

    // console.log('formData1 from localStorage:', formData1);
    // console.log('id_announce from localStorage:', id_announce);
    // console.log('nbre from formData:', n);
    // console.log('date from formData:', d);
    // console.log('heure from formData:', h);

    var templateParams = {
        pnom: nom,
        mail: usermail,
        phone: tel,
        date: d,
        nbre: n,
        time: h,
        id: loisir?.id_announce ?? id_announce,
        user: data.userId,
        prix: price,
        montant:0,
    };

    const verifyLoisResForm = ()=>{
        Reservation.verifyLoisirRes(templateParams)
        .then((res:any)=>{
            if(res.data.status === 422)
            {
                //console.log(res.data.errors)
                setErrors(res.data.errors)
                setOpen(false)
            }else{
                setOpen(true)
            }
        }).catch((error:any)=>{
            console.log("Erreur lors de l'appel a l'API ",error)
        })
    }

    function submitForm() {
        //e.preventDefault()
       setOpen(false)
        // Add montant if price_announce exists
        if (price) {
            templateParams.montant = parseFloat(n ?? formData.nbre) * parseFloat(price);
        }else{
            templateParams.montant = parseFloat(n ?? formData.nbre) * 0 ;
        }

        // console.log('templateParams.montant',templateParams.montant)
        // console.log('templateParams',templateParams)


        Reservation.loisirRes(templateParams)
        .then((res: any) => {
            if (res.data.status === 201) {
                toast.success(res.data.message);
                localStorage.removeItem('identifiant_announce');
                localStorage.removeItem('formData');
                localStorage.removeItem('prix');

                navigate("/hometourisme");
                //console.log(res);
            } else if(res.data.status === 422){
               setErrors(res.data.errors)
            }else {
                toast.error(res.data.message);
                //console.log(res);
            }
        })
        .catch((err: any) => {
            toast.error('Erreur merci de reessayer !');
            console.log(err);
        })
        .finally(() => {
            setLoading(false);
        })


    }

    // Fonction de gestion de la soumission du formulaire
    const handleSubmitPay = (event : any) => {
        event.preventDefault();
        verifyLoisResForm();
        //setShowPopup(true);
    };

    const handleSubmitReserve = (event : any) => {
        event.preventDefault();
        //verifyLoisResForm();
        submitForm();
        //localStorage.removeItem('formData');
        //localStorage.removeItem('prix');
        //localStorage.removeItem('identifiant_announce');
        //setFormData({}); // Réinitialisez formData à un objet vide
       // navigate("/hometourisme");
    };

    const handleSubmitPayPlusTard = (event : any) => {
        event.preventDefault();
        submitForm();
    };

    // Callback de succès du popup de paiement
    const handlePopupSuccess = () => {
        setShowPopup(false);
        submitForm();
        setFormData({}); // Réinitialisez formData à un objet vide
    };

    // Callback d'annulation du popup de paiement
    const handlePopupCancel = () => {
        setShowPopup(false);
    };

    const handlePopupStripeSuccess = () => {
        submitForm();
        setFormData({}); // Réinitialisez formData à un objet vide
    };

    useEffect(() => {

        if (!data) {
            navigate("/Connexion");
        }
        localStorage.setItem('formData', JSON.stringify(formData));

           axios
                .get(`${process.env.REACT_APP_BASE_URL}/api/get/info/website`)
                .then((res) => {
                if (res.data.status === 200 ) {
                    setCurr(res.data.currency);
                    localStorage.setItem('id_currency', res.data.currency.id_currency);
                } else {
                    console.warn("Réponse inattendue de l'API :", res.data);
                }
                })
                .catch((err) => {
                console.error("Erreur lors de l'appel à l'API :", err);
                });
        

        getPriceDollar();
        getLoisir();

        const sessionId = localStorage.getItem('sessionId');
        if(sessionId){
            getPaymentStatus(sessionId).then(response => {
                //console.log(response.data)
                if (response.data.status === 'succeeded') {
                    handlePopupStripeSuccess();
                    //navigate("/hometourisme");
                }
                }).catch(error => {
                    console.error('Erreur lors de la récupération du statut de paiement:', error);
            });
        }
        localStorage.removeItem('sessionId');
        const timer = setTimeout(() => {
            // Après 5 secondes, masquer le spinner et rediriger l'utilisateur
            setLoading(false);
        }, 2000); // 5000 millisecondes = 5 secondes

        // Nettoyer le timer si le composant est démonté avant la fin du délai
        return () => clearTimeout(timer);
    }, [formData]);

    useEffect(()=>{
        localStorage.removeItem('formData');
      },[])

    const today = new Date().toISOString().split("T")[0];
    const {t} = useTranslation() as {t:(key:string)=>string}

    let totalPaid =  parseFloat(formData.nbre) * (loisir?.price_announce ?? 0)
      
        useEffect(() => {
              if (curr) {
          
              setOptions({
                  id_currency: curr.id_currency,
                  success_url: window.location.origin ,
                  cancel_url: window.location.href,
                  amount:totalPaid,
                  customer: {
                  id: data.azId,
                  first_name: data.userLastname ?? '',
                  last_name: data.userName ?? '',
                  email: data.userMail,
                  phone: data.userTel,
                  code_country: 'BJ'
                  },
                  seller_number: 1
              });
              }
            }, [curr,totalPaid])


  return (
    <div>
       {loading ? (
                // Afficher le spinner tant que loading est true
                <Loading />
            ) : (
                <>

          <BackImage/>
       {/* formulaire de prise de rdv */}
       <div className='relative flex justify-center md:py-20  border-gray-200 md:mt-20 s:mt-2'>
            <form action="" className='bg-white md:w-[800px] xs:w-[700px] s:w-[270px] sm:w-[350px] h-full py-10 shadow-2xl flex flex-col space-y-6 justify-center items-center'>
                <h2 className='xs:w-[400px] s:w-[240px] sm:w-[300px] text-center text-2xl text-orange-400 '>
                    {t("Réservation pour")} <span className="underline decoration-dotted decoration-orange-400"> {loisir?.title_announce}</span>
                </h2>
                <p className='xs:w-[400px] s:w-[240px] sm:w-[300px] text-center text-lg'>{t("Veuillez remplir tous les champs du formulaire afin que votre demande de prise de rendez-vous soit prise en compte")}</p>
                <input type='hidden'   required/>
                <div className='flex flex-col space-y-3 '>
                    <label className='text-lg'>{t("Nom & Prénom")} <span className='text-red-600'>*</span></label>
                    <input name='name' value={nom} onChange={(e) => setNom(e.currentTarget.value)}  type='text' style={{backgroundColor:"#d9d9d9"}} className='border-none xs:w-[600px] s:w-[240px] sm:w-[300px] h-14' required/>
                     {errors?.nom && <p className='text-red-500'>{errors?.nom}</p>}
                </div>

                <div className='flex flex-col space-y-3 '>
                    <label className='text-lg'>{t("Adresse e-mail")} <span className='text-red-600'>*</span></label>
                    <input name='mail' type='email' value={usermail} onChange={(e) => setUserEmail(e.currentTarget.value)} style={{backgroundColor:"#d9d9d9"}} className='border-none xs:w-[600px] s:w-[240px] sm:w-[300px] h-14' required/>
                    {errors?.mail && <p className='text-red-500'>{errors?.mail}</p>}
                </div>

                <div className='flex flex-col space-y-3 '>
                    <label className='text-lg'>{t("Numero de portable")} <span className='text-red-600'>*</span></label>
                    <input name='numero' value={tel} onChange={(e) => setTel(e.currentTarget.value)}  type='tel' style={{backgroundColor:"#d9d9d9"}} className='border-none xs:w-[600px] s:w-[240px] sm:w-[300px] h-14' required/>
                     {errors?.phone && <p className='text-red-500'>{errors?.phone}</p>}
                </div>

                <div className='flex flex-col space-y-3 '>
                    <label className='text-lg'>{t("Date d'arrivée")} <span className='text-red-600'>*</span></label>
                    <input name='date'  type='date'
                    value={formData.date || ""}
                    onChange={handleInputChange}
                    style={{backgroundColor:"#d9d9d9"}} 
                    className='border-none xs:w-[600px] s:w-[240px] sm:w-[300px] h-14' 
                    required
                    min={today}
                    />
                     {errors?.date && <p className='text-red-500'>{errors?.date}</p> }
                </div>

                <div className='flex flex-col space-y-3 '>
                    <label className='text-lg'> {t("Heure d'arrivée")} <span className='text-red-600'>*</span></label>
                    <input name='time'  type='time'
                    value={formData.time || ""}
                    onChange={handleInputChange}
                    style={{backgroundColor:"#d9d9d9"}} className='border-none xs:w-[600px] s:w-[240px] sm:w-[300px] h-14' required/>
                     {errors?.time && <p className='text-red-500'>{errors?.time}</p>}
                </div>


                {/* <div className='flex flex-col space-y-3 '>
                    <label className='text-lg'>Lieu de loisir <span className='text-red-600'>*</span></label>
                    <input readOnly value={loisir?.title_announce}  type='text' style={{backgroundColor:"#d9d9d9"}}  className='border-none xs:w-[600px] s:w-[240px] sm:w-[300px] h-14' required/>
                </div> */}

                <div className='flex flex-col space-y-3 '>
                    <label className='text-lg'>{t("Nombre de ticket")} <span className='text-red-600'>*</span></label>
                    <input name='nbre' min="0"
                    value={formData.nbre || ""}
                    onChange={handleInputChange}
                    type='number' style={{backgroundColor:"#d9d9d9"}}  className='border-none xs:w-[600px] s:w-[240px] sm:w-[300px] h-14' required/>
                     {errors?.nbre && <p className='text-red-500'>{errors?.nbre}</p>}
                </div>
                {loisir?.price_announce && (
                    <div className='flex flex-col space-y-3 '>
                        <label className='text-lg'>{t("Voulez-vous faire le paiement")} ? <span className='text-red-600'>*</span></label>
                        <div className='flex space-x-10'>
                        <button onClick={handleSubmitPayPlusTard} type='submit' className='xs:w-[270px] s:w-[100px] sm:w-[120px] h-14 bg-[#233D4D] text-white text-lg rounded'>{t("Plus tard")}</button>
                        <button onClick={handleSubmitPay} type='submit' className='xs:w-[270px] s:w-[100px] sm:w-[120px] h-14 border-2 border-[#233D4D] text-[#233D4D] rounded text-lg'>{t("Payer")}</button>
                        </div>
                    </div>
                )}



                {/* <PopopPaiement/> */}

                 {/* <button onClick={handleSubmitReserve} type='submit' style={{backgroundColor:"#FCCA46", color:"white"}} className='w-40 h-12 text-lg rounded '>Reserver</button> */}

                 {/* {showPopup && (
                    <PaymentPopup
                        open={showPopup}
                        montant={parseFloat(formData.nbre) * (loisir?.price_announce ?? 0)}
                        onSuccess={handlePopupSuccess}
                        userNom={data.userLastname}
                        userPrenom={data.userName}
                        email={data.userMail}
                        user_Id={data.userId}
                        dollarP={Math.round(priceD ?? 1)}
                        onClose={handlePopupCancel}
                    />
                )} */}
            </form>

            {
                open && (
                <div className="fixed inset-0 flex items-center justify-center bg-gray-500 bg-opacity-50 z-50">
                    <div className="bg-white rounded-lg p-6 w-full max-w-3xl relative max-h-screen overflow-y-auto">
                        {/* Bouton de fermeture à l'intérieur du modal */}
                        <button
                        onClick={() => setOpen(false)}
                        className="absolute top-3 right-3 text-red-500 text-2xl"
                    >
                        &times;
                    </button>
                        <Create item="Rechargement de la carte AZ"  options={options} onSuccess={submitForm} ></Create>
                    </div>
                </div>
            )
            }

          </div>
          <Footer />
                </>
            )}
    </div>
  )
}

export default ReservationTourisme